import axiosEmail from '@/services/axios/axiosEmail'

export default class EmailService {
  static async getSignInUrl() {
    return axiosEmail
      .get('auth/microsoft-sign-in-url')
      .then(res => res.data.data)
  }

  static async testarConfiguracoesImapSmtp(body) {
    return axiosEmail
      .post('auth/testar-configuracoes-imap-smtp', body)
      .then(res => res.data.data)
  }

  static async testarConfiguracoesMicrosoft(body) {
    return axiosEmail
      .post('auth/testar-configuracoes-microsoft', body)
      .then(res => res.data.data)
  }
}
